export enum Environment {
  Test = "test",
  Alpha = "alpha",
  Beta = "beta",
  Gamma = "gamma",
  Production = "prod",
}

export const getCurrentEnvironment = (): Environment => {
  const parts = window.location.hostname.split(".");
  switch (parts[0]) {
    case Environment.Alpha:
    case Environment.Beta:
    case Environment.Gamma:
    case Environment.Production:
      return parts[0] as Environment;
    default:
      if (window.location.hostname.includes("a2z.com")) {
        return Environment.Production;
      }
      return Environment.Test;
  }
};

export const isNonProductionEnvironment = (): boolean => {
  const environment = getCurrentEnvironment();
  return (
    environment !== Environment.Gamma && environment !== Environment.Production
  );
};

const featureFlagMapping = {};

export default featureFlagMapping;
